var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_vm._v(" "),_c('csrf-token-generator',{attrs:{"form-handle":_vm.formHandle}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }